(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["companio-story"] && !Shopify.designMode) return;
  try {
    
  /* Our Story gallery. Deliberately NOT companio-rail.js: rail.js clones its
     item set, and these tiles are a finite list of real photographs. */
  (function () {
    'use strict';

    var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
    var GLIDE_MS = 380;

    function initStoryGallery(root) {
      if (root.dataset.storyReady) return;
      root.dataset.storyReady = '1';

      var track = root.querySelector('[data-story-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-story-slide]'));
      if (slides.length === 0) return;

      var labelEl = root.querySelector('[data-story-label]');
      var copyEl = root.querySelector('[data-story-copy]');
      var indexEl = root.querySelector('[data-story-index]');
      var prevBtn = root.querySelector('[data-story-prev]');
      var nextBtn = root.querySelector('[data-story-next]');
      var active = -1;

      function slideWidth() {
        if (slides.length > 1) {
          var d = slides[1].offsetLeft - slides[0].offsetLeft;
          if (d > 0) return d;
        }
        return slides[0].offsetWidth || track.clientWidth;
      }

      function currentIndex() {
        var w = slideWidth();
        if (w <= 0) return 0;
        var i = Math.round(track.scrollLeft / w);
        if (i < 0) i = 0;
        if (i > slides.length - 1) i = slides.length - 1;
        return i;
      }

      function sync() {
        var i = currentIndex();
        if (i !== active) {
          active = i;
          var slide = slides[i];
          if (labelEl) labelEl.textContent = slide.getAttribute('data-story-tile-label') || '';
          if (copyEl) copyEl.textContent = slide.getAttribute('data-story-tile-copy') || '';
          if (indexEl) indexEl.textContent = String(i + 1);
        }
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= max;
      }

      /* scrollTo({behavior:'smooth'}) is a silent no-op in some environments -
         it left this gallery completely dead in the first build. Tween
         scrollLeft ourselves, and keep a timer that guarantees the final
         position even if requestAnimationFrame never runs. */
      function glideTo(target) {
        var max = track.scrollWidth - track.clientWidth;
        if (target < 0) target = 0;
        if (target > max) target = max;

        if (REDUCE.matches || typeof window.requestAnimationFrame !== 'function') {
          track.scrollLeft = target;
          sync();
          return;
        }

        var from = track.scrollLeft;
        var start = null;
        var done = false;

        var guard = setTimeout(function () {
          if (done) return;
          done = true;
          track.scrollLeft = target;
          sync();
        }, GLIDE_MS + 400);

        function frame(now) {
          if (done) return;
          if (start === null) start = now;
          var p = Math.min(1, (now - start) / GLIDE_MS);
          var eased = 1 - Math.pow(1 - p, 3);
          track.scrollLeft = from + (target - from) * eased;
          if (p < 1) {
            window.requestAnimationFrame(frame);
          } else {
            done = true;
            clearTimeout(guard);
            track.scrollLeft = target;
            sync();
          }
        }
        window.requestAnimationFrame(frame);
      }

      function go(dir) {
        glideTo(track.scrollLeft + dir * slideWidth());
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

      var settle = null;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(sync, 90);
      }, { passive: true });

      /* Figma layers transparent (prev)/(next) hit areas over the two halves of
         the strip. Done as a tap rather than an overlay so touch swipe still
         works: an overlay would sit on top of the scroll container. */
      var downX = null;
      var downY = null;
      track.addEventListener('pointerdown', function (e) {
        downX = e.clientX;
        downY = e.clientY;
      });
      track.addEventListener('pointerup', function (e) {
        if (downX === null) return;
        var moved = Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY);
        downX = null;
        downY = null;
        if (moved > 8) return;
        var box = track.getBoundingClientRect();
        go(e.clientX - box.left < box.width / 2 ? -1 : 1);
      });

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          active = -1;
          sync();
        }, 200);
      });

      sync();
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-story-gallery]').forEach(initStoryGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
